module.exports = __webpack_public_path__ + "img/clock.1bb6756d.svg";